export default __webpack_public_path__ + "static/media/slide1.4a214b59.webp";